
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    title: { type: String, required: true },
    text: { type: String, required: true }
  }
});
